import { ITranslations } from '@kurtosys/types/common/ITranslations.js';

import { replacePlaceholders } from '../commonUtils/replacePlaceholders.js';

export class TranslationHelper {
	targetTranslations: ITranslations = {};
	fallbackTranslations: ITranslations = {};
	constructor(targetTranslations: ITranslations, fallbackTranslations: ITranslations) {
		this.targetTranslations = targetTranslations;
		this.fallbackTranslations = fallbackTranslations;
		this.translate = this.translate.bind(this);
	}
	translate(key: string, placeholders?: any): any {
		const translation = this.getTranslation(key);
		return placeholders ? replacePlaceholders({ values: placeholders, text: translation }) : translation;
	}
	getTranslation(key: string): string {
		return this.targetTranslations[key] || this.fallbackTranslations[key] || key;
	}
}
